<script lang="ts" setup>
const { t } = useI18n()
const localePath = useLocalePath()

const links = computed((): UFooterLink[] => {
  return [
    {
      activeClass: 'font-bold',
      label: t('navigation.updates'),
      to: 'https://updates.thecompaniesapi.com/',
    },
    {
      activeClass: 'font-bold',
      label: t('navigation.terms'),
      to: localePath('product-terms'),
    },
    {
      activeClass: 'font-bold',
      label: t('navigation.privacy'),
      to: localePath('product-privacy'),
    },
    {
      activeClass: 'font-bold',
      label: t('navigation.faq'),
      to: localePath('product-faq'),
    },
    {
      activeClass: 'font-bold',
      label: t('navigation.status'),
      to: 'https://status.thecompaniesapi.com/en/',
    },
  ]
})
</script>

<template>
  <footer class="relative select-none">
    <div class="absolute bottom-[calc(var(--footer-height)/3)] left-0 mb-6 size-full overflow-hidden opacity-50 lg:mb-4">
      <BaseGlow class="absolute left-0 mb-4 flex size-full items-center justify-center" />
    </div>

    <div class="footer-height relative z-10 flex w-full items-center justify-between">
      <UDivider class="absolute left-0 top-0 h-0 w-full overflow-visible">
        <BaseEmblem />
      </UDivider>

      <UContainer class="footer-height flex size-full flex-col-reverse items-center justify-center gap-2 lg:mx-auto lg:flex-row lg:justify-between">
        <div class="flex flex-col items-center gap-2 sm:flex-row lg:order-1 lg:flex-1 lg:flex-row-reverse lg:justify-end">
          <span class="text-sm text-gray-600 lg:mb-0 dark:text-gray-400">© {{ new Date().getFullYear() }} The Companies API</span>

          <LayoutLocaleSelector class="lg:mr-3" />
        </div>

        <ul class="flex flex-wrap items-center justify-center lg:order-2 lg:flex-1 lg:flex-nowrap">
          <li
            v-for="link of links"
            :key="link.label"
            class="truncate"
          >
            <UButton
              :label="link.label"
              :to="link.to"
              variant="link"
            />
          </li>
        </ul>

        <div class="flex items-center justify-center lg:order-3 lg:flex-1 lg:justify-end">
          <ClientOnly>
            <LayoutSocketsButton />
          </ClientOnly>
        </div>
      </UContainer>
    </div>
  </footer>
</template>

<style lang="postcss">
.footer-height {
  height: var(--footer-height);
  max-height: var(--footer-height);
  background: rgb(var(--ui-background));
}
</style>
